import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center">
                <i className="ri-book-open-line text-2xl text-primary-400"></i>
              </span>
              <span className="text-lg font-bold font-heading text-white">韩国漫画网</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              好看的韩国漫画在线阅读平台，提供无遮韩漫大全，每日更新热门连载。
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">漫画分类</h4>
            <div className="flex flex-col gap-2">
              {categories.filter(c => c.slug !== 'all').slice(0, 6).map(cat => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              <Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">全部漫画</Link>
              <Link to="/category/action" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">动作漫画</Link>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">网站信息</h4>
            <div className="flex flex-col gap-2">
              <p className="text-sm text-background-400">韩漫在线免费阅读平台</p>
              <p className="text-sm text-background-400">每日更新 品质保证</p>
              <p className="text-sm text-background-400">正版授权 放心阅读</p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 韩国漫画网 - 好看的韩国漫画在线免费阅读平台. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="QQ">
              <i className="ri-qq-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}